<div *ngIf="isCommercialOptIn" class="alert alert-success alert-dismissible fade show">
  <span>Opt in is activated</span>
  <button (click)="isCommercialOptIn = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div>
  <p class="alert alert-secondary" style="background-color: #eff0f3;">
    <a href="mailto:{{urgentEmailAddress}}">{{ urgentEmailAddress }}</a>
    {{ urgentInfoMessage }}<br>
    <a href="mailto:{{supportEmailAddress}}">{{ supportEmailAddress }}</a>
    For non-urgent support matters (e.g. asking developer questions, seeking documentation)<br>
    <a href="mailto:{{onBoardingAddress}}">{{ onBoardingAddress }}</a>
    For onboarding inquiries (e.g. questions related to current services, new orders, LOAs, turn-ups/turn-downs, and
    Portal inquiries) <br>
    Or create a trouble ticket directly via the JIRA service desk portal to reach both groups.<br>
    <a href="{{jiraServiceDeskPortalUrl}}">{{ jiraServiceDeskPortalUrl }}</a>
    <br><br>
    Refer to the "Help Desk Support Contacting McKay Brothers and Quincy Data and FAQ's"
    document in the <a routerLink="/document">Downloads</a> section for details.
    <br><br>
    Thank you.<br>
  </p>
  <br>
</div>
<div *permission="['canEditYours']">
  <div *ngIf="!commercialOptIn">
    <p class="alert alert-secondary" style="background-color: #6f96d069;">
      You can receive marketing and new services notifications directly in your email.<br>
      Please <a (click)="activateCommercialOptIn()" style="color: #0062cc;">click here</a> to elect to receive
      occasional
      updates from McKay Brothers or Quincy Data via email.<br>
    </p>
    <br>
  </div>
</div>
<div *roles="['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_CLIENT_SUPER', 'ROLE_CLIENT_ADMIN']">
  <table class="table" id="company_info_table" style="width: 40%;">
    <tr>
      <th style="padding: 0.25rem;">Number of active users / total users created</th>
      <th *permission="['canListUsers']" style="padding: 0.25rem; text-align: right; color: #007bff"><a
        routerLink="/{{companyUniqid}}/{{companyUniqid}}/users"
        routerLinkActive="router-link-active">
        {{ numberOfActiveUsers }} / {{ numberOfTotalUsers }}</a></th>
      <th *notAllowedPermissions="['canListUsers']"
          style="padding: 0.25rem; text-align: right; color: #000000">
        {{ numberOfActiveUsers }} / {{ numberOfActiveUsers }}
      </th>
    </tr>
    <tr>
      <td style="padding: 0.25rem;">Company account created</td>
      <td style="padding: 0.25rem; text-align: right">{{ companyCreatedAt | date : "MMM d, y" }}</td>
    </tr>
    <tr>
      <td style="padding: 0.25rem;">Last modified</td>
      <td style="padding: 0.25rem; text-align: right">{{ companyUpdatedAt | date : "MMM d, y" }}</td>
    </tr>
  </table>
  <br>
</div>
<ng-container *notAllowedPermissions="['isCompanyVendor']">
  <h6><b>Latest announcements ( <a routerLink="/{{companyUniqid}}/announcementLog">See all</a> )</b>
  </h6>
  <div *ngIf="announcements?.length !== 0">
    <div *ngFor="let announcement of announcements">
      <table border="1" class="table" style="width: 60%;">
        <tr>
          <th style="width: 75%; padding: 0.25rem;">{{ announcement?.subject }}</th>
          <th
            style="width: 20%; padding: 0.25rem; text-align: right; color: #007bff">
            Date: {{ announcement?.sentAt | date: "MMM dd, y HH:mm:ss" }} (UTC)
          </th>
        </tr>
        <tr>
          <td colspan="2" height="200" style="padding: 0.25rem; overflow:auto">
            <div [innerHTML]="announcement?.announcementSentMessage[0]?.message"
                 style="height:200px;overflow: auto;"></div>
          </td>
        </tr>
      </table>
      <br>
    </div>
  </div>
  <div *ngIf="announcements.length === 0">
    <p style="color: #A82831">No data found</p>
  </div>
</ng-container>
